<template>
  <div class="icon-circle" :style="circleStyle">
    <component v-if="icon" :is="icon" :size="iconSize" />
    <span v-else class="icon-text" :style="textStyle">{{ initials }}</span>
  </div>
</template>

<script>
export default {
  name: 'IconCircle',
  props: {
    // Either provide an icon component or initials text
    icon: {
      type: Object,
      default: null
    },
    initials: {
      type: String,
      default: ''
    },
    // Size of the circle
    size: {
      type: Number,
      default: 32
    },
    // Background color
    bgColor: {
      type: String,
      default: '#e1edff'
    },
    // Text/icon color
    color: {
      type: String,
      default: '#406396'
    }
  },
  computed: {
    circleStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        minWidth: `${this.size}px`,
        backgroundColor: this.bgColor,
        color: this.color
      };
    },
    iconSize() {
      // Icon should be about half the circle size
      return Math.floor(this.size / 2);
    },
    textStyle() {
      // Font size should be about 3/8 of circle size
      return {
        fontSize: `${Math.floor(this.size * 0.375)}px`
      };
    }
  }
}
</script>

<style scoped>
.icon-circle {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.icon-text {
  font-weight: 500;
  user-select: none;
}
</style>
